import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context/AuthContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default function HiringPortalProvider({ children }) {
  useEffect(() => {
    const previous = window.__PACE_HIRING__;
    window.__PACE_HIRING__ = true;
    return () => {
      if (previous === undefined) delete window.__PACE_HIRING__;
      else window.__PACE_HIRING__ = previous;
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  );
}
